module.exports = __webpack_public_path__ + "img/PM10μg.258353bb.png";